var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ListPicker_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import BlueprintComponent from '../core/blueprintComponent';
import Icon from './icon';
import './pillBox';
import '../../scss/components/listPicker.scss';
/** The name of the module */
export const name = 'ListPicker';
/** Class names for the module */
export const ClassNames = {
    Default: 'bp-c-listPicker',
    JavaScript: 'js-listPicker',
    Wrapper: 'bp-c-listPicker_wrapper',
};
let ListPicker = ListPicker_1 = class ListPicker extends BlueprintComponent {
    /**
       * Create an ListPicker component
       * @param {Options} options Options to initialize the component with
       */
    constructor(options) {
        super(name, options);
    }
    /**
       * Create an instance of this module
       * @param {Options} options Options to initialize the component with
       */
    static create(options) {
        return new ListPicker_1(options);
    }
    /**
       * Initialize the module
       */
    async init() {
        super.init();
        this.element = await BlueprintComponent.loadElement(name, this.options);
        this.initWrapper();
    }
    /**
       * Create wrapper and icon and inject it into the DOM around the listPicker
       * Due to SEO Performance reasons so there isn't an additional wrapper on page render
       */
    initWrapper() {
        const wrapper = document.createElement('div');
        wrapper.classList.add(ClassNames.Wrapper);
        if (this.options.label) {
            wrapper.setAttribute('data-label', this.options.label);
        }
        // Insert wrapper before this.element
        this.element.parentNode.insertBefore(wrapper, this.element);
        // Insert this.element inside of wrapper
        wrapper.appendChild(this.element);
        // Create the arrowDown icon
        let arrowIcon;
        if (this.options.iconSize) {
            arrowIcon = Icon.createElement({ name: `arrowDown--${this.options.iconSize}` });
        }
        else {
            arrowIcon = Icon.createElement({ name: 'arrowDown--xsmall' });
        }
        // Insert arrowIcon inside of wrapper
        wrapper.appendChild(arrowIcon);
    }
};
ListPicker = ListPicker_1 = __decorate([
    injectable(name)
], ListPicker);
export default ListPicker;
// Create answer modules in the hydration queue
BlueprintComponent.instantiate(name);
